exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/desv/producao/ITN/srvHCWaba/src/app/shared/form-debug/form-debug.component.scss
// module id = ../../../../../src/app/shared/form-debug/form-debug.component.scss
// module chunks = main